import React from "react"
import { Text, Container, FlexContainer } from "@carrotfertility/carotene"

type CurrencyWarningProps = {
  companyCurrencyCode: string
  selectedCurrencyCode: string
}

export default function CurrencyWarning({
  companyCurrencyCode,
  selectedCurrencyCode
}: CurrencyWarningProps): JSX.Element {
  const showCurrencyError = selectedCurrencyCode === companyCurrencyCode

  return (
    <FlexContainer>
      {showCurrencyError ? null : (
        <Container sx={{ marginBottom: "medium" }} background="lightGrey" padding="medium" borderRadius="8px">
          <Text weight="semibold">
            This currency does not match your company’s location. Your credit card statement may show this charge in
            your local currency.
          </Text>
        </Container>
      )}
    </FlexContainer>
  )
}
